import { render } from "./VaBeneNotificationListPage.vue?vue&type=template&id=4f95e378&ts=true"
import script from "./VaBeneNotificationListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneNotificationListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__